// import {AiFillTwitterCircle,AiFillLinkedin, AiFillGithub} from 'react-icons/ai';
function Footer() {
return (<></>
    // <div className="flex justify-center m-3 gap-11 rounded-md text-5xl cursor-pointer">
    //     <a href="https://www.linkedin.com/in/md-ashif-reza/"><AiFillLinkedin/></a>
    //     <a href="https://github.com/mdashifreza"><AiFillGithub/></a>
    //     <a href="https://twitter.com/Ashif_rez"><AiFillTwitterCircle /></a>
    // </div>
)
}
export default Footer;
